import { memo } from 'react';

function UnacknowledgedMarker({ backgroundColor, borderColor, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M22.78 18V6L12.39 0L2 6V18L12.39 24L22.78 18Z" fill={backgroundColor} />
      <path
        d="M12.39 1.15L21.78 6.57V17.42L12.39 22.84L3 17.42V6.58L12.39 1.15ZM12.39 0L2 6V18L12.39 24L22.78 18V6L12.39 0Z"
        fill={borderColor}
      />
      <path
        d="M19.8899 12C13.9499 18 10.8299 18 4.88989 12C10.8299 6 13.9499 6 19.8899 12Z"
        fill={borderColor}
      />
      <path
        d="M12.3899 15C14.0467 15 15.3899 13.6569 15.3899 12C15.3899 10.3431 14.0467 9 12.3899 9C10.733 9 9.38989 10.3431 9.38989 12C9.38989 13.6569 10.733 15 12.3899 15Z"
        fill={backgroundColor}
      />
      <path
        d="M8.11217 5.66065L7.05151 6.72131L17.6652 17.335L18.7258 16.2743L8.11217 5.66065Z"
        fill={backgroundColor}
      />
      <path
        d="M7.11217 6.66486L6.05151 7.72552L16.6652 18.3392L17.7258 17.2785L7.11217 6.66486Z"
        fill={borderColor}
      />
    </svg>
  );
}

export default memo(UnacknowledgedMarker);
